import type { StageAudit, StageAuditEntry } from '@/services/loans'

/** Every entry the Audit Trail lists: the flat list when the API sends one,
 *  otherwise each stage segment's events plus the unplaced ones. The Trail, its
 *  Events stat and the dossier's AUDIT badge all count this, so they cannot
 *  disagree. */
export function stageAuditEntries(audit: StageAudit): StageAuditEntry[] {
  return audit.entries ?? [...audit.segments.flatMap((s) => s.events), ...audit.unplaced_events]
}
